const xdownloaderConfig = {
  tableTitle: '',
  tableSelector: '.ns-table-wrap',
  excludeTableSelector: '',
  downloadText: "XLS",
  mergeStrings: [],
  numFmt: (cell, cellIndex, rowIndex) => {
    if ((String(cell.value).replace(' ', '')).trim().match(/^[+-]?(\d*\.\d+|\d+\.\d*|\d+)$/) && !['2018', '2019', '2020', '2021', '2022', '2023', '2024'].includes((String(cell.value).replace(' ', '')).trim())) {
      cell.value = parseFloat(String(cell.value).trim().replace(' ', ''));
      if (String(cell.value).indexOf('.') > -1) {
        cell.numFmt = '#,##0.??';
      }
      else {
        cell.numFmt = '#,##0';
      }
      // console.log(cell._address, cell.value)
    }
  },
  tableCellFormatter: (h) => {
    let cell = document.createElement('td');
    cell.innerHTML = h.innerHTML;
    let superscript = cell.querySelector('.superscript');
    let superscriptContent = '';
    if (superscript) {
      superscriptContent = '(' + superscript.innerText + ')';
      superscript.parentNode.removeChild(superscript);
    }

    let cellContent = '';
    let cellSpans = cell.querySelectorAll('span');
    if (cellSpans.length > 0) {
      cellSpans.forEach(span => {
        if(!/<span\b[^>]*>(.*?)<\/span>/i.test(span.innerHTML)) {
          cellContent += span.innerText
        }
      })
    } else {
      let paragraph = cell.querySelector('p');
      cellContent += paragraph?.innerText;
    }

    return cellContent.replace(/'/g, '').replace(/’/g, '').replace(/–/g, '-').replace(/,/g, '.').replace(/–/g, '-').replace(/,/g, '.');
  },
  styles: [
    {
      class: 'ns-horizontal-left',
      font: {
        size: 12,
      },
      border: {
        bottom: {
          style: 'thin',
          color: {
            argb: 'FF000000'
          }
        },
      },
    },
    {
      class: 'ns-horizontal-right',
      font: {
        size: 12,
      },
      border: {
        bottom: {
          style: 'thin',
          color: {
            argb: 'FF000000'
          }
        },
      },
    },
    {
      class: 'ns-horizontal-center',
      font: {
        size: 12,
      },
      border: {
        bottom: {
          style: 'thin',
          color: {
            argb: 'FF000000'
          }
        },
      },
    },
    {
      class: 'head_chf',
      font: {
        bold: true,
        size: 12,
        color: {
          argb: 'FF000000'
        }
      },
      head: true,
      index: 10
    },
    {
      class: 'head',
      font: {
        bold: true,
        size: 12,
      },
      border: {
        top: {
          style: 'thin',
          color: {
            argb: 'FF312880'
          },
          index: 10
        },
      },
    },
    {
      class: 'line_bold',
      font: {
        bold: true,
        size: 12,
      },
    },
    {
      class: 'bline_bold',
      font: {
        bold: true,
        size: 12,
      },
      border: {
        bottom: {
          style: 'medium',
          color: {
            argb: 'FF000000'
          },
        },
      },
    },
    {
      class: 'bline_bold_space',
      font: {
        bold: true,
        size: 12,
        color: {
          argb: 'FF000000'
        }
      },
    },
    {
      class: 'ns-borderbottom-line',
      border: {
        bottom: {
          style: 'thin',
          color: {
            argb: 'FF34495e'
          },
        },
      },
    },
    {
      class: 'ns-bordertop-line_blue',
      border: {
        top: {
          style: 'thin',
          color: {
            argb: 'FF312880'
          },
        },
      },
    },
    {
      class: 'ns-borderbottom-bline_blue',
      border: {
        top: {
          style: 'medium',
          color: {
            argb: 'FF312880'
          },
        },
        bottom: {
          style: 'medium',
          color: {
            argb: 'FF312880'
          },
        },
      },
    },
    {
      class: ['ns-borderbottom-bline_blue', 'ns-bordertop-line_blue'],
      border: {
        top: {
          style: 'thin',
          color: {
            argb: 'FF312880'
          },
        },
        bottom: {
          style: 'medium',
          color: {
            argb: 'FF312880'
          },
        },
      },
    },
    {
      class: 'noline',
      border: {
        bottom: {
          style: 'none'
        }
      }
    },
    {
      class: 'nl',
      border: {
        bottom: {
          style: 'none'
        }
      }
    },
    {
      class: 'ns-backgroundcolor-tabellenhg',
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {
          argb: 'efeef5'
        }
      }
    }
  ]
};

export default xdownloaderConfig;
